// Libs
import { ReactElement, useContext } from 'react';
import clsx from 'clsx';
// App
import styles from './page-body.module.scss';
import { PageBodyProps } from './page-body.interfaces';
import { LeftPanelContext } from '../left-panel/left-panel-context';

const PageBody = (props: PageBodyProps): ReactElement => {
  const { children } = props;
  const { isOpen: isLeftPanelCollapsed } = useContext(LeftPanelContext);

  return <div className={clsx(styles.body, isLeftPanelCollapsed && styles.leftPanelCollapsed)}>{children}</div>;
};

export default PageBody;
